module.exports = __webpack_public_path__ + "img/color_metal_logo-partner-engineering.70e1c398.png";